import React from "react";
import { secciones } from "../../../datos";
import { Tarjeta } from "../../Cards";

export function Clientes() {
  return (
    <section className="py-24 bg-white relative overflow-hidden">
      {/* Decorative */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-[#C81416]/4 rounded-full translate-x-1/3 -translate-y-1/3 blur-3xl pointer-events-none" />

      {secciones[0].clientes.map((item, index) => (
        <div className="container mx-auto px-4 relative z-10" key={index}>
          {/* Header */}
          <div className="text-center mb-16">
            <span className="inline-flex items-center gap-2 px-4 py-2 bg-[#151C84]/10 text-[#151C84] text-sm font-bold rounded-full mb-6 border border-[#151C84]/15">
              <span className="w-2 h-2 rounded-full bg-[#C81416]" />
              Nuestros Clientes
            </span>
            <h2
              className="text-4xl md:text-5xl font-extrabold text-[#151C84] mb-4"
              data-aos="fade-up"
            >
              {item.subtitle}
            </h2>
            <div className="flex items-center justify-center gap-2 mt-4">
              <div className="h-0.5 w-12 bg-[#C81416] rounded-full" />
              <div className="h-1.5 w-1.5 rounded-full bg-[#C81416]" />
              <div className="h-0.5 w-12 bg-[#C81416] rounded-full" />
            </div>
          </div>

          {/* Cards */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 xl:gap-8">
            {item.list.map((card, i) => {
              const { title, valor, icono } = card;
              const colors = ["#151C84", "#C81416", "#0d125c", "#8c0e0f"];
              return (
                <div
                  key={i}
                  className="transform transition-all duration-300 hover:-translate-y-3"
                  data-aos="fade-up"
                  data-aos-delay={i * 80}
                >
                  <Tarjeta
                    titulo={title}
                    valor={valor}
                    icono={icono}
                    colorFondo={colors[i % colors.length]}
                    colorTexto="#FFFFFF"
                  />
                </div>
              );
            })}
          </div>
        </div>
      ))}
    </section>
  );
}
